import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService extends CrudService {
  constructor(public override http: HttpClient) {
    super('language', http);
  }

  /**
   * Check Language field is unique
   * @returns object
   */
  checkUniqueLanguageName(languageName: string, id: number) {
    return this.http.get(
      `${this.baseUrl}/check-unique-language/${languageName}/${id}`
    );
  }
}
